var React = require('react');

function ContentCircleStar (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fillRule":"evenodd"},React.createElement("path",{"d":"M149.5,1 C231.514285,1 298,67.4857147 298,149.5 C298,231.514285 231.514285,298 149.5,298 C67.4857147,298 1,231.514285 1,149.5 C1,67.4857147 67.4857147,1 149.5,1 Z M150,53 L121.492415,110.762676 L57.7475179,120.025352 L103.873759,164.987324 L92.9848305,228.474648 L150,198.5 L207.015169,228.474648 L196.126241,164.987324 L242.252482,120.025352 L178.507585,110.762676 L150,53 Z"})));
}

ContentCircleStar.defaultProps = {"role":"presentation","viewBox":"0 0 299 299","version":"1.1"};

module.exports = ContentCircleStar;

ContentCircleStar.default = ContentCircleStar;
